export type EntityValidationType = "base" | "required" | "too_long";

export type EntityValidationResult<T extends EntityBase> = { [key in keyof T]?: EntityValidationType };

export interface EntityValidationResultMap<T extends EntityBase> {
  [key: string]: EntityValidationResult<T> | undefined;
}

export type EntityValidator<T extends EntityBase> = (entity: T) => EntityValidationResult<T>;

export type EntityValidatorCreator<T extends EntityBase, P> = (param: P) => EntityValidator<T>;

export class EntityValidationError<T extends EntityBase> extends Error {
  private result: EntityValidationResult<T>;

  constructor(result: EntityValidationResult<T>) {
    super(`EntityValidationError: ${JSON.stringify(result)}`);
    this.result = result;
  }

  public getResult() {
    return this.result;
  }
}

// tslint:disable-next-line:max-classes-per-file
export class EntityValidationMapError<T extends EntityBase> extends Error {
  private result: { [key: string]: EntityValidationResult<T> };

  constructor(result: { [key: string]: EntityValidationResult<T> }) {
    super(`EntityValidationError: ${JSON.stringify(result)}`);
    this.result = result;
  }

  public getResult() {
    return this.result;
  }
}

export function validate<T extends EntityBase>(entity: T, validator: EntityValidator<T>) {
  const result = validator(entity);
  if (Object.values(result).some(Boolean)) {
    throw new EntityValidationError(result);
  }
  return null;
}

export function validateAll<T extends EntityBase>(entities: T[], validator: EntityValidator<T>) {
  const resultMap: { [key: string]: EntityValidationResult<T> } = {};
  entities.forEach(entity => {
    const result = validator(entity);
    if (Object.values(result).some(Boolean)) {
      resultMap[entity.id] = result;
    }
  });
  if (Object.keys(resultMap).length > 0) {
    throw new EntityValidationMapError(resultMap);
  }
  return null;
}



// WEBPACK FOOTER //
// ./frontend/src/lib/entities/validation.ts